import { useState } from "react";
import { ActionIcon } from "@mantine/core";
import { IconTransform } from "@tabler/icons-react";
import ConverterModal from "./ConverterModal";

export interface ConverterRow {
  fields: string[];
  divisors?: number[];
  result: string;
}

export interface ConverterProps {
  rows: ConverterRow[];
  type?: "multiply" | "divide";
  fieldId: string;
  [key: string]: any;
}

interface CustomConverterProps extends ConverterProps {}

export default function CustomConverter(props: CustomConverterProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div>
      <ActionIcon
        onClick={() => setIsModalOpen(true)}
        size="sm"
        title="Open converter">
        <IconTransform size={16} />
      </ActionIcon>

      {isModalOpen && (
        <ConverterModal
          onClose={() => setIsModalOpen(false)}
          converterProps={props}
        />
      )}
    </div>
  );
}
